import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-24 pb-16 px-4 overflow-hidden bg-[#030014]">
      <div className="absolute inset-0 z-0">
        <motion.div 
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3], rotate: [0, 90, 0] }} 
          transition={{ duration: 15, repeat: Infinity, ease: "linear" }} 
          className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] bg-emerald-900/20 rounded-full blur-[120px]" 
        />
        <motion.div 
          animate={{ scale: [1.2, 1, 1.2], opacity: [0.2, 0.4, 0.2], rotate: [0, -90, 0] }} 
          transition={{ duration: 12, repeat: Infinity, ease: "linear" }} 
          className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-purple-900/20 rounded-full blur-[100px]" 
        />
      </div>
      
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 z-[1]" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#030014]/50 to-[#030014] z-[2]" />
      
      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }} 
          animate={{ opacity: 1, scale: 1 }} 
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="inline-block px-4 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-300 text-sm font-bold tracking-widest uppercase mb-8">
            Professional Reiki & Spiritual Brand
          </div>
          <h1 className="text-7xl md:text-9xl font-extrabold tracking-tighter mb-8 leading-[0.9]">
            <span className="block text-white opacity-90 text-[0.8em]">MASTER YOUR</span>
            <span className="text-gradient">ENERGY.</span>
          </h1>
        </motion.div>

        <motion.p 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.8, delay: 0.4 }} 
          className="text-lg md:text-xl text-slate-400 mb-12 max-w-4xl mx-auto font-light leading-relaxed"
        >
          Dai Kho Limited is a multi-dimensional wellness brand. From professional <span className="text-white font-medium">Usui Reiki healing</span> to spiritually-inspired <span className="text-white font-medium">streetwear</span>, we bridge the gap between energy work and the physical world.
        </motion.p>

        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.8, delay: 0.6 }} 
          className="flex flex-col sm:flex-row items-center justify-center gap-6"
        >
          <a 
            href="#reiki" 
            className="group relative px-10 py-5 rounded-full bg-white text-black font-bold text-xl transition-all duration-300 hover:scale-105 active:scale-95 overflow-hidden"
          >
            <span className="relative z-10 uppercase tracking-wider">Book a Session</span>
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl" />
          </a>
          <a 
            href="#merch" 
            className="px-10 py-5 rounded-full glass-panel text-white font-bold text-xl transition-all duration-300 hover:bg-white/10 hover:border-white/30 uppercase tracking-wider"
          >
            Shop Merch
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;